import { gql } from '@apollo/client'

import { listFragment } from 'js/magazine/lib/fragments'

export const MAGAZINES_LIST = gql`
    query MagazinesList(
        $parentGuid: String
        $limit: Int!
        $offset: Int!
        $orderBy: OrderBy
        $orderDirection: OrderDirection # $dateFrom: String # $dateTo: String
    ) {
        entities(
            parentGuid: $parentGuid
            subtypes: ["magazine"]
            limit: $limit
            offset: $offset
            orderBy: $orderBy
            orderDirection: $orderDirection # dateFrom: $dateFrom # dateTo: $dateTo
        ) {
            total
            edges {
                guid
                ${listFragment}
            }
        }
    }
`
